














import Vue from 'vue';
import { Logger } from '@/Shared/Logger';
import { Dictionary } from 'vue-router/types/router';

export default Vue.extend({
  name: 'ErrorList',
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      errors: this.value
    };
  },
  props: {
    options: {
      type: Array as () => Array<{
        label: string;
        variant: string;
        value: any;
      }>
    },
    value: Object as () => Dictionary<string>
  },
  methods: {
    radioChanged($event: any) {
      this.$emit('change', $event);
    }
  },
  watch: {
    value(newValue) {
      this.errors = newValue;
    }
  },
  computed: {
      errorKeys(): string[] {
          return Object.keys(this.errors);
      }
  }
});
